export const STATES = [
  { key: "AL", name: "Alabama", display_name: "Alabama", type: "state" },
  { key: "AK", name: "Alaska", display_name: "Alaska", type: "state" },
  { key: "AZ", name: "Arizona", display_name: "Arizona", type: "state" },
  { key: "AR", name: "Arkansas", display_name: "Arkansas", type: "state" },
  { key: "CA", name: "California", display_name: "California", type: "state" },
  { key: "CO", name: "Colorado", display_name: "Colorado", type: "state" },
  { key: "CT", name: "Connecticut", display_name: "Connecticut", type: "state" },
  { key: "DE", name: "Delaware", display_name: "Delaware", type: "state" },
  { key: "FL", name: "Florida", display_name: "Florida", type: "state" },
  { key: "GA", name: "Georgia", display_name: "Georgia", type: "state" },
  { key: "HI", name: "Hawaii", display_name: "Hawaii", type: "state" },
  { key: "ID", name: "Idaho", display_name: "Idaho", type: "state" },
  { key: "IL", name: "Illinois", display_name: "Illinois", type: "state" },
  { key: "IN", name: "Indiana", display_name: "Indiana", type: "state" },
  { key: "IA", name: "Iowa", display_name: "Iowa", type: "state" },
  { key: "KS", name: "Kansas", display_name: "Kansas", type: "state" },
  { key: "KY", name: "Kentucky", display_name: "Kentucky", type: "state" },
  { key: "LA", name: "Louisiana", display_name: "Louisiana", type: "state" },
  { key: "ME", name: "Maine", display_name: "Maine", type: "state" },
  { key: "MD", name: "Maryland", display_name: "Maryland", type: "state" },
  { key: "MA", name: "Massachusetts", display_name: "Massachusetts", type: "state" },
  { key: "MI", name: "Michigan", display_name: "Michigan", type: "state" },
  { key: "MN", name: "Minnesota", display_name: "Minnesota", type: "state" },
  { key: "MS", name: "Mississippi", display_name: "Mississippi", type: "state" },
  { key: "MO", name: "Missouri", display_name: "Missouri", type: "state" },
  { key: "MT", name: "Montana", display_name: "Montana", type: "state" },
  { key: "NE", name: "Nebraska", display_name: "Nebraska", type: "state" },
  { key: "NV", name: "Nevada", display_name: "Nevada", type: "state" },
  { key: "NH", name: "New Hampshire", display_name: "New Hampshire", type: "state" },
  { key: "NJ", name: "New Jersey", display_name: "New Jersey", type: "state" },
  { key: "NM", name: "New Mexico", display_name: "New Mexico", type: "state" },
  { key: "NY", name: "New York", display_name: "New York", type: "state" },
  { key: "NC", name: "North Carolina", display_name: "North Carolina", type: "state" },
  { key: "ND", name: "North Dakota", display_name: "North Dakota", type: "state" },
  { key: "OH", name: "Ohio", display_name: "Ohio", type: "state" },
  { key: "OK", name: "Oklahoma", display_name: "Oklahoma", type: "state" },
  { key: "OR", name: "Oregon", display_name: "Oregon", type: "state" },
  { key: "PA", name: "Pennsylvania", display_name: "Pennsylvania", type: "state" },
  { key: "RI", name: "Rhode Island", display_name: "Rhode Island", type: "state" },
  { key: "SC", name: "South Carolina", display_name: "South Carolina", type: "state" },
  { key: "SD", name: "South Dakota", display_name: "South Dakota", type: "state" },
  { key: "TN", name: "Tennessee", display_name: "Tennessee", type: "state" },
  { key: "TX", name: "Texas", display_name: "Texas", type: "state" },
  { key: "UT", name: "Utah", display_name: "Utah", type: "state" },
  { key: "VT", name: "Vermont", display_name: "Vermont", type: "state" },
  { key: "VA", name: "Virginia", display_name: "Virginia", type: "state" },
  { key: "WA", name: "Washington", display_name: "Washington", type: "state" },
  { key: "WV", name: "West Virginia", display_name: "West Virginia", type: "state" },
  { key: "WI", name: "Wisconsin", display_name: "Wisconsin", type: "state" },
  { key: "WY", name: "Wyoming", display_name: "Wyoming", type: "state" },
  { key: "DC", name: "District of Columbia", display_name: "District of Columbia", type: "state" },
];
